<template>
  <div>
    <div class="form-group form-group--set">
      <div class="form-label">
        <label
          class="control-label"
          :for="`role_artist_name_ja_${index}`">アーティスト名
        </label>
      </div>
      <div class="form-item">
        <input
          :id="`role_artist_name_ja_${index}`"
          v-model="localAssignment.nameJa"
          class="form-control"
          type="text"
          :disabled="localAssignment.artistId"
          @input="onArtistFieldChange('nameJa', $event.target.value)">
        <p
          v-if="errors.artist_name_ja"
          class="error-text">
          {{ errors.artist_name_ja[0] }}
        </p>
      </div>
    </div>
    <div class="form-group form-group--set">
      <div class="form-label">
        <label
          class="control-label"
          :for="`role_artist_name_kana_${index}`">アーティスト名 （カナ）
        </label>
      </div>
      <div class="form-item">
        <input
          :id="`role_artist_name_kana_${index}`"
          v-model="localAssignment.nameKana"
          class="form-control"
          type="text"
          :disabled="localAssignment.artistId"
          @input="onArtistFieldChange('nameKana', $event.target.value)">
        <p
          v-if="errors.artist_name_kana"
          class="error-text">
          {{ errors.artist_name_kana[0] }}
        </p>
      </div>
    </div>
    <div class="form-group form-group--set">
      <div class="form-label">
        <label
          class="control-label"
          :for="`role_artist_name_en_${index}`">アーティスト名 （アルファベット表記）
        </label>
      </div>
      <div class="form-item">
        <input
          :id="`role_artist_name_en_${index}`"
          v-model="localAssignment.nameEn"
          class="form-control"
          type="text"
          :disabled="localAssignment.artistId"
          @input="onArtistFieldChange('nameEn', $event.target.value)">
        <p
          v-if="errors.artist_name_en"
          class="error-text">
          {{ errors.artist_name_en[0] }}
        </p>
      </div>
    </div>
    <div
      v-if="performerMode"
      class="form-group form-group--set">
      <div class="form-item">
        <div
          v-if="localAssignment.performanceRoles.length > 0"
          class="role-assignment-row__selected-roles">
          <span
            v-for="roleKey in localAssignment.performanceRoles"
            :key="`performance-${roleKey}`"
            class="role-chip">
            {{ getPerformanceRoleLabel(roleKey) }}
            <span
              class="role-chip__remove"
              @click="removePerformanceRole(roleKey)">×</span>
          </span>
        </div>
        <div
          v-else
          class="c-color-caution">
          ※設定したアーティストの役割を選択してください。
        </div>
        <button
          type="button"
          class="c-btn c-btn--narrow"
          @click="$emit('show-performance-role-modal', index)">
          <span class="c-btn__icon-add">
            <span></span>
          </span>
          役割を選択
        </button>
        <button
          type="button"
          class="c-btn c-btn--delete-large c-btn--narrow c-btn--right"
          style="top: auto; transform: none"
          @click.prevent="$emit('delete', 'performance')">
          削除
          <span class="c-btn__icon-minus">
            <span></span>
          </span>
        </button>
        <p
          v-if="performanceErrors.length"
          class="error-text">
          {{ performanceErrors[0] }}
        </p>
      </div>
    </div>
    <div
      v-else
      class="form-group form-group--set">
      <div class="form-item">
        <div
          v-if="localAssignment.productionRoles.length > 0"
          class="role-assignment-row__selected-roles">
          <span
            v-for="roleKey in localAssignment.productionRoles"
            :key="`production-${roleKey}`"
            class="role-chip">
            {{ getProductionRoleLabel(roleKey) }}
            <span
              class="role-chip__remove"
              @click="removeProductionRole(roleKey)">×</span>
          </span>
        </div>
        <div
          v-else
          class="c-color-caution">
          ※設定したアーティストの役割を選択してください。
        </div>
        <button
          type="button"
          class="c-btn c-btn--narrow"
          @click="$emit('show-production-role-modal', index)">
          <span class="c-btn__icon-add">
            <span></span>
          </span>
          役割を選択
        </button>
        <button
          type="button"
          class="c-btn c-btn--delete-large c-btn--narrow c-btn--right"
          style="top: auto; transform: none"
          @click.prevent="$emit('delete', 'production')">
          削除
          <span class="c-btn__icon-minus">
            <span></span>
          </span>
        </button>
        <p
          v-if="productionErrors.length"
          class="error-text">
          {{ productionErrors[0] }}
        </p>
      </div>
    </div>
    <div
      class="form-group-wrap__btn-wrap"
      style="margin: 60px auto 50px auto">
      <button
        v-if="isLast"
        type="button"
        class="c-btn c-btn--narrow"
        @click="$emit('show-artist-modal')">
        マイアーティストから追加
        <span class="c-btn__icon-add">
          <span></span>
        </span>
      </button>
      <button
        v-if="isLast"
        type="button"
        class="c-btn c-btn--narrow"
        @click="$emit('add-new-artist')">
        新規アーティスト追加
        <span class="c-btn__icon-add">
          <span></span>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RoleAssignmentRow',
  props: {
    assignment: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    performanceCatalog: {
      type: Array,
      default: () => [],
    },
    productionCatalog: {
      type: Array,
      default: () => [],
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    isLast: {
      type: Boolean,
      default: false,
    },
    showControls: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localAssignment: this.cloneAssignment(this.assignment),
    }
  },
  computed: {
    performerMode() {
      return !!this.$listeners['show-performance-role-modal']
    },
    displayName() {
      if (this.assignment.nameJa || this.assignment.name_ja) {
        return this.assignment.nameJa || this.assignment.name_ja
      }
      if (this.assignment.nameEn || this.assignment.name_en) {
        return this.assignment.nameEn || this.assignment.name_en
      }
      if (this.assignment.nameKana || this.assignment.name_kana) {
        return this.assignment.nameKana || this.assignment.name_kana
      }
      return '未設定のアーティスト'
    },
    performanceErrors() {
      return this.errors.performance_roles || []
    },
    productionErrors() {
      return this.errors.production_roles || []
    },
  },
  watch: {
    assignment: {
      deep: true,
      handler(value) {
        this.localAssignment = this.cloneAssignment(value)
      },
    },
  },
  methods: {
    cloneAssignment(source = {}) {
      return {
        ...source,
        nameJa: source.nameJa || source.name_ja || '',
        nameKana: source.nameKana || source.name_kana || '',
        nameEn: source.nameEn || source.name_en || '',
        type: source.type || 1,
        artistId: source.artistId || source.artist_id || null,
        performanceRoles: Array.isArray(source.performanceRoles)
          ? [...source.performanceRoles]
          : [],
        productionRoles: Array.isArray(source.productionRoles)
          ? [...source.productionRoles]
          : [],
      }
    },
    getPerformanceRoleLabel(roleKey) {
      const role = this.performanceCatalog.find(r => r.key === roleKey)
      return role ? role.labels.ja : roleKey
    },
    removePerformanceRole(roleKey) {
      const index = this.localAssignment.performanceRoles.indexOf(roleKey)
      if (index !== -1) {
        this.localAssignment.performanceRoles.splice(index, 1)
        this.emitChange()
      }
    },
    getProductionRoleLabel(roleKey) {
      const role = this.productionCatalog.find(r => r.key === roleKey)
      return role ? role.labels.ja : roleKey
    },
    removeProductionRole(roleKey) {
      const index = this.localAssignment.productionRoles.indexOf(roleKey)
      if (index !== -1) {
        this.localAssignment.productionRoles.splice(index, 1)
        this.emitChange()
      }
    },
    emitChange() {
      const payload = {
        ...this.localAssignment,
        performanceRoles: [...this.localAssignment.performanceRoles],
        productionRoles: [...this.localAssignment.productionRoles],
      }
      this.$emit('update', payload)
    },
    onPerformanceRolesChange() {
      this.emitChange()
    },
    onProductionRolesChange() {
      this.emitChange()
    },
    onArtistFieldChange(field, value) {
      this.localAssignment[field] = value
      this.emitChange()
    },
  },
}
</script>

<style scoped>
.role-assignment-row__selected-roles {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
  border: 1px solid #c0c0c0;
  background-color: #ffffff;
  padding: 8px 10px;
}

.role-chip {
  display: inline-flex;
  align-items: center;
  background-color: #1976d2;
  color: white;
  padding: 4px 10px;
  border-radius: 16px;
  font-size: 14px;
}

.role-chip__remove {
  margin-left: 6px;
  cursor: pointer;
  font-weight: bold;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.3);
  transition: background-color 0.2s;
}

.role-chip__remove:hover {
  background-color: rgba(255, 255, 255, 0.5);
}

.c-btn--danger {
  border-color: #dc3545;
  color: #dc3545;
}

.c-btn--danger:hover {
  background-color: #dc3545;
  color: #fff;
}

@media screen and (max-width: 895px) {
  .form-item-inline {
    flex-direction: column;
  }
}
</style>
